export const createKey = (userData, timestamp, name,customName) => {
  const fileExtension = name.split(".").pop();
  const fileName = `${userData.id}_${timestamp}_${customName}.${fileExtension}`;
  return 'original/' + fileName;
}

export const ParamsData = ({userData, audioFile, customName,createKey:_createkey = createKey,planning = null}) => {
  const timestamp = new Date().getTime();
  const metadata = {
    "x-amz-meta-user-id": userData.id + "" || "",
    "x-amz-meta-user-firstname": userData.first_name || "",
    "x-amz-meta-user-lastname": userData.last_name || "",
    "x-amz-meta-user-email": userData.email || "",
    "x-amz-meta-user-country": userData.country || "",
    "x-amz-meta-user-city": userData.city || "",
    "x-amz-meta-user-role": userData.role?.join(", ") || "",
    "x-amz-meta-user-phone": userData.phone || "",
    "x-amz-meta-user-birthday": userData.birthday || "",
    "x-amz-meta-user-timestamp": timestamp.toString(),
    "x-amz-meta-duration": (audioFile?.duration || "")+"",
    "x-amz-meta-size": (audioFile?.size || "")+"",
    "x-amz-meta-plan-id": (planning?.session_id || "")+"",
  };
  const params = {
    Bucket: "mentu-class-audios",
    Key: _createkey(userData,timestamp,audioFile?.name,customName),
    Body: audioFile,
    ContentType: audioFile.type,
    Metadata: metadata,
  };

  return params;
}